import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Phone, Clock } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsApp = () => {
    window.open("https://wa.me/6588921053?text=Hi, I'd like to book a valet service", "_blank");
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo.jpg" 
                alt="Valet Find Me" 
                className="h-14 w-14 rounded-full object-cover shadow-lg"
              />
              <div>
                <h3 className="text-2xl font-bold">Valet Find Me</h3>
                <p className="text-sm text-slate-400">Professional Drive Home Services</p>
              </div>
            </div>
            <p className="text-slate-300 mb-6 leading-relaxed max-w-md">
              Drink, don't drive, be home safe. Your trusted partner for professional valet 
              and drive home services, building lasting relationships one ride at a time.
            </p>
            <div className="flex items-center space-x-4">
              <button
                onClick={handleWhatsApp}
                className="bg-yellow-400 hover:bg-yellow-500 text-black px-6 py-3 rounded-lg font-semibold transition-all hover:scale-105"
              >
                <MessageSquare className="w-4 h-4 inline mr-2" />
                Book Now
              </button>
            </div>
            <div className="mt-6">
              <a 
                href="https://ValetFindMe.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-yellow-400 hover:text-yellow-300 font-semibold"
              >
                ValetFindMe.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-300 hover:text-yellow-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <a href="#services" className="text-slate-300 hover:text-yellow-400 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-slate-300 hover:text-yellow-400 transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/careers" className="text-slate-300 hover:text-yellow-400 transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-slate-300 hover:text-yellow-400 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="w-5 h-5 text-yellow-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-slate-300">+65 8892 1053</p>
                </div>
              </li>
              <li className="flex items-start">
                <MessageSquare className="w-5 h-5 text-yellow-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-slate-300">WhatsApp Available</p>
                </div>
              </li>
              <li className="flex items-start">
                <Clock className="w-5 h-5 text-yellow-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-slate-300">9:00 PM - 4:00 AM</p>
                  <p className="text-sm text-slate-400">7 Days a Week</p>
                  <p className="text-sm text-yellow-400 mt-1">After hours services available</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} Valet Find Me. All rights reserved.
            </p>
            <p className="text-slate-400 text-sm">
              Safe rides, trusted service, lasting relationships.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
